import { t } from '../../i18n-t';
import type { FormConfig } from '../types';

export const getDocumentAssessmentResultFormConfig = () => {
  return {
    AssessmentId: {
      fieldId: 'AssessmentId',
      formLabel: t('assessmentResults.fields.Assessment'),
    },
    OversightAssessmentId: {
      fieldId: 'OversightAssessmentId',
      formLabel: t('assessmentResults.fields.OversightAssessment'),
    },
    InternalAuditReportId: {
      fieldId: 'InternalAuditReportId',
      formLabel: t('assessmentResults.fields.InternalAuditReport'),
    },
    DocumentIds: {
      fieldId: 'DocumentIds',
      formLabel: t('assessmentResults.fields.Document'),
    },
    Rating: {
      fieldId: 'Rating',
      formLabel: t('assessmentResults.fields.Rating'),
      displayType: { displayType: 'rating', ratingKey: 'performance_result' },
      allowAsConditionSource: true,
    },
    Rationale: {
      fieldId: 'Rationale',
      formLabel: t('assessmentResults.fields.Rationale'),
      allowTargetConditions: true,
      displayType: { displayType: 'textarea' },
    },
    TestDate: {
      fieldId: 'TestDate',
      formLabel: t('assessmentResults.fields.TestDate'),
      displayType: { displayType: 'date' },
      allowAsConditionSource: true,
    },
    files: {
      fieldId: 'files',
      formLabel: t('assessmentResults.fields.newFiles'),
      allowTargetConditions: true,
    },
  } as const satisfies FormConfig;
};
